import React from 'react';

const Loading = (props) => {
  return (
    <div className={`${props.className || '3x'}`} style={props.style}>
      <i className="fas fa-spinner fa-spin"></i>
    </div>
  )
}

export default Loading;
